<template>
  <transition name="slide-fade">
    <div v-if="visible" class="footer-notify" :class="[`footer-notify-${type}`]" :style="value.failFileUrl ? 'width:363px' : 'width:294px'">
      <div class="footer-notify-content">
        <div class="footer-notify-icon"></div>
        <div class="footer-notify-text">
          <div class="footer-notify-title">{{ title }}</div>

          <div class="footer-notify-body">
            <a href="javascript:void(0)" class="footer-notify-message">{{ message }}</a>
            <a
              v-if="value.operationName == 1 && value.taskStatus == 3"
              href="javascript:void(0)"
              class="footer-notify-button"
              @click="toDetail(value)"
            >
              查看详情
            </a>
            <a v-if="value.fileUrl" href="javascript:void(0)" class="footer-notify-button" @click="download(value)">
              下载{{ value.operationName }}文件
            </a>
            <a v-if="value.failFileUrl" href="javascript:void(0)" class="footer-notify-button" @click="download(value, 'failFileUrl')">
              下载失败数据
            </a>
          </div>
        </div>
        <div class="footer-notify-close" @click="close">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { _bus } from "@/utils/index"

export default {
  name: "ImportExportFooterNotify",
  props: {
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "info",
      validator: value => ["success", "warning", "error", "info"].includes(value)
    },
    duration: {
      type: Number,
      default: 5000
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      timer: null,
      downloadThrottle: false, // 添加节流标志
      throttleDelay: 1000 // 节流延迟时间(毫秒)
    }
  },
  computed: {
    iconClass() {
      const iconMap = {
        success: "el-icon-success",
        warning: "el-icon-warning",
        error: "el-icon-error",
        info: "el-icon-info"
      }
      return iconMap[this.type]
    }
  },
  methods: {
    show() {
      this.visible = true
      console.log(this.value, "----valuealue")
      this.startTimer()
    },
    close() {
      this.visible = false
      this.clearTimer()
      this.$emit("close")
    },
    startTimer() {
      this.clearTimer()
      this.timer = setTimeout(() => {
        this.close()
      }, this.duration)
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    openNotifyPage() {
      this.$notifyPage.show()
    },
    download(row, type) {
      // 节流控制，防止频繁点击
      if (this.downloadThrottle) {
        return
      }

      this.downloadThrottle = true

      try {
        const url = type ? row.failFileUrl : row.fileUrl
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const a = document.createElement("a")
            a.download = row.fileName || "download"
            a.href = URL.createObjectURL(blob)
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            URL.revokeObjectURL(a.href)
          })
      } finally {
        // 延迟重置节流标志
        setTimeout(() => {
          this.downloadThrottle = false
        }, this.throttleDelay)
      }
    },
    // 打开详情
    toDetail(data) {
      console.log(data)
      _bus.$emit("openExportDodule", true)
      setTimeout(() => {
        _bus.$emit("changeActiveType", {
          actionType: data.operationType == 1 ? "export" : "import"
        })
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-notify {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 99999;
  width: 363px;
  padding: 15px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.footer-notify-content {
  display: flex;
  align-items: center;
}

.footer-notify-icon {
  margin-right: 10px;
  font-size: 24px;
}

.footer-notify-text {
  flex-grow: 1;
  margin-left: -12px;
}

.footer-notify-title {
  font-weight: bold;
  margin-bottom: 8px;
}

.footer-notify-close {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s;
  position: absolute;
  right: 14px;
  top: 14px;
}

.footer-notify-close:hover {
  opacity: 1;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.footer-notify-success {
  border-left: 4px solid #67c23a;
}
.footer-notify-warning {
  border-left: 4px solid #e6a23c;
}
.footer-notify-error {
  border-left: 4px solid #f56c6c;
}
.footer-notify-info {
  border-left: 4px solid #409eff;
}
.footer-notify-message {
  color: #666666;
  @include ellipsis-single(139px);
  display: inline-block;
  cursor: text;
}
.footer-notify-button {
  color: #409eff;
  display: inline-block;
  margin-left: 12px;
}
.footer-notify-body {
  display: flex;
  align-items: center;
}
</style>
